import React, { useState } from "react";
import CustomDataGrid from "../../components/CustomDataGrid/CustomDataGrid.tsx";
import SideBar from "../../layouts/sidebar/SideBar.tsx";
import Leo from "./../../../assets/images/Leo.png";
import { Button, Grid } from "@mui/material";
import searchIcon from "./../../../assets/icons/search.ico";
import bin from "./../../../assets/icons/reject.png";
import edit from "./../../../assets/icons/edit.png";
import linkactiveImg from "./../../../assets/images/linkActive.png";
import linkDeactiveImg from "./../../../assets/images/linkDective.png";
import approveImg from "./../../../assets/icons/checked.png";
import AutoCompleteMultiSelect from "../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import "./../NewRestaurantRequest/NewRestaurantRequest.css";
import RestaurantDetailsDialog from "./RestaurantDetailsDialog/RestaurantDetailsDialog.tsx";
import CancelReasonDialog from "./CancelReasonDialog/CancelReasonDialog.tsx";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import loadingGif from "./../../../assets/images/loading.gif";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import LoadingView from "../../components/LoadingView/LoadingView.js";
import TopHeader from "../../../components/TopHeader.tsx";
import CancelationDialog from "./CancelationDialog/CancelationDialog.tsx";
import CourierDetailsDialog from "./CourierDetailsDialog/CourierDetailsDialog.tsx";

function CourierRequest(props) {
  const columnsdatas = [
    {
      field: "legalName",
      headerName: "Courier Name",
      renderCell: (params) => (
        <div>
          <span
            onClick={() => {
              handleClickOpen(params.value, params.row.id);
            }}
            style={{ color: "blue", cursor: "pointer" }}
          >
            {params.value === "a" ? "Sole Provider" : params.value}
          </span>
        </div>
      ),
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "phoneNumber",
      headerName: "Contact Number",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "address",
      headerName: "Address",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "firstName",
      headerName: "Applied by user name",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "businessType",
      headerName: "Business Type",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "requestDate",
      headerName: "Request Date",
      align: "center",
      renderCell: (params) => <div>{dateFormated(params.value)}</div>,
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "approvalStatusDescription",
      headerName: "Status",
      renderCell: (params) => (
        <div
          className={`${
            params.value === "Approved"
              ? "approve"
              : params.value === "Pending"
              ? "pending"
              : params.value === "Link Activated"
              ? "approve"
              : "reject"
          } RoundedStatus`}
        >
          {params.value}
        </div>
      ),
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
  ];

  const apiAddress = process.env.REACT_APP_SECRET;

  const dateFormated = (props) => {
    var d = new Date(props);
    return d.toDateString();
  };

  const [dataRows, setDataRows] = React.useState([]);

  const [selectedData, setSelectedData] = React.useState([]);
  const [enableOptions, setEnableOptions] = React.useState(false);
  const getselectedData = (props) => {
    console.log("props: " + props);

    var temp = props;
    setSelectedData(temp);
    if (props.length > 0) {
      setEnableOptions(true);
    } else {
      setEnableOptions(false);
    }
  };
  const typrOfMenuDatas = [
    { id: 1, title: "Online" },
    { id: 2, title: "In-store" },
  ];
  const [autoCompleteValue, setAutoCompleteValue] = React.useState([]);
  const addValue = (props) => {
    setAutoCompleteValue(props);
  };

  const [clickedCourier, setClickedCourier] = React.useState("");
  const handleClickOpen = (props, id) => {
    setopenDetailsDialog(true);
    console.log(id);
    var data = dataRows.find((x) => x.id === id);
    console.log("data: " + data.legalName);
    setClickedCourier(data);
  };

  const [openCancelReasonDialog, setopenCancelReasonDialog] =
    React.useState(false);
  const [openDetailsDialog, setopenDetailsDialog] = React.useState(false);
  const [clickedRestaurantDetails, setClickedRestaurantDetails] =
    React.useState([]);
  const [allRestaurantDetails, setAllRestaurantDetails] = React.useState([]);
  const handleClickopenCancelReasonDialog = () => {
    setopenCancelReasonDialog(true);
    var tempData = [];
    var allTempData = [];
    selectedData.map((data, index) => {
      var dt = dataRows.find((x) => x.id === data);
      var obj = {
        id: dt.id,
        title: dt.legalName,
      };
      tempData.push(obj);
    });

    dataRows.map((dt, index) => {
      var obj = {
        id: dt.id,
        title: dt.legalName,
      };
      allTempData.push(obj);
    });
    setAllRestaurantDetails(allTempData);
    console.log("tempData: " + tempData[0].title);
    setClickedRestaurantDetails(tempData);
  };
  const handleAddopenCancelReasonDialog = (AddItemData) => {
    setopenCancelReasonDialog(AddItemData);
    loadData();
  };
  const handleopenDetailsDialog = (AddItemData) => {
    setopenDetailsDialog(AddItemData);
    loadData();
  };

  const [loading, setloading] = React.useState(false);

  const [dataLoaded, setdataLoaded] = React.useState(false);

  React.useEffect(() => {
    loadData();
  }, []);

  const approvedData = async (props) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>You want to approve this?</p>
            <button onClick={onClose} className="btn-no btn-common">
              No
            </button>
            <button
              className="btn-yes btn-common"
              onClick={() => {
                // this.handleClickDelete();
                approve(props);
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
    });
  };

  console.log(dataRows);

  const activeLinkData = async (props, text) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>{text}</p>
            <button onClick={onClose} className="btn-no btn-common">
              No
            </button>
            <button
              className="btn-yes btn-common"
              onClick={() => {
                // this.handleClickDelete();
                approve(props);
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
    });
  };

  const approve = async (props) => {
    const token = localStorage.getItem("gotasteadmintoken");

    if (token) {
    } else {
      window.location.href = "/login";
    }
    setloading(true);
    SetloadingModal(true);
    axios({
      method: "put",
      url: apiAddress + "/api/Courier/updateCourierRequests/" + props,
      data: selectedData,
    })
      .then(function (response) {
        setloading(false);
        SetloadingModal(false);
        console.log(response);
        toast.success("Successfully Saved", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        loadData();
      })
      .catch(function (error) {
        setloading(false);
        SetloadingModal(false);
        console.log(error);
        toast.error("Error" + error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const [collection, setCollection] = useState([]);
  const loadData = async () => {
    const token = localStorage.getItem("gotasteadmintoken");

    if (token) {
    } else {
      window.location.href = "/login";
    }
    axios({
      method: "get",
      url: apiAddress + "/api/Courier",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then(function (response) {
        console.log(response.data);
        var ls = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.courierCompanyDetails.id,
            legalName: dt.courierCompanyDetails.fullName,
            phoneNumber: dt.courierPersonnel.phoneNumber,
            address: dt.courierPersonnel.homeAddress,
            firstName: dt.courierPersonnel.firstName,
            email: dt.courierPersonnel.emailAddress,
            businessType: dt.courierCompanyDetails.courierBusinessType,
            requestDate: dt.courierCompanyDetails.creationDate,
            approvalStatusDescription:
              dt.courierCompanyDetails.approvalStatusDescription,
          };
          ls.push(obj);
        });
        setDataRows(ls);
        setCollection(response.data);
        var state = false;
        setdataLoaded(state);
      })
      .catch(function (error) {});
  };
  const [loadingModal, SetloadingModal] = React.useState(false);

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };

  return (
    <div>
      <LoadingView open={loadingModal} close={closeLoadingModal} />
      <ToastContainer />
      <TopHeader />
      <div className="p-5">
        <div className="d-flex justify-content-center">
          <h3>Courier Request</h3>
        </div>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mt={2}
          mb={2}
        >
          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <div
                  className={` ${
                    enableOptions ? "" : "disable"
                  }  roundedCorner`}
                  onClick={() => {
                    approvedData(1);
                  }}
                >
                  <img src={approveImg} alt="" style={{ width: "1rem" }} />{" "}
                  Approve
                </div>
              </Grid>
              <Grid item>
                <div
                  className={` ${
                    enableOptions ? "" : "disable"
                  }  roundedCorner`}
                  onClick={() => {
                    handleClickopenCancelReasonDialog();
                  }}
                >
                  <img src={bin} alt="" style={{ width: "1rem" }} /> Reject
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container flexDirection={"column"} alignItems={"center"}>
              <Grid item>
                <img src={searchIcon} alt="" style={{ width: "1rem" }} />
              </Grid>
              <Grid item>Search</Grid>
            </Grid>
          </Grid>
        </Grid>
        {dataRows.length > 0 ? (
          <CustomDataGrid
            columns={columnsdatas}
            dataRows={dataRows}
            getselectedData={getselectedData}
            selectedRows={selectedData}
            isLoading={loading}
          />
        ) : (
          "Nothing found"
        )}
      </div>
      <CancelationDialog
        open={openCancelReasonDialog}
        onClose={handleAddopenCancelReasonDialog}
        dialogName={"Add On"}
        restaurantName={clickedRestaurantDetails}
        allRestaurant={allRestaurantDetails}
      />
      {openDetailsDialog ? (
        <CourierDetailsDialog
          open={openDetailsDialog}
          clickedCourier={clickedCourier}
          collection={collection}
          onClose={handleopenDetailsDialog}
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default CourierRequest;
